




















import { DataModules } from "@/store/modules/data";
import { Vue, Component } from "vue-property-decorator";

@Component({
  components: {
    "ticket-departments-table": () =>
      import(
        "@/components/app/admin/settings/brands/tickets/ticketDepartmentsTable.vue"
      )
  }
})
export default class TicketDepartmentsContextualise extends Vue {
  public $refs!: {
    ticketDepartmentsTable: HTMLFormElement;
  };

  public createDepartment() {
    if (!this.canCreate) return;

    this.$store.dispatch(
      `data/${DataModules.TICKETS_DEPARTMENTS}/openAddEditModal`,
      {
        events: {
          success: () => {
            this.$refs.ticketDepartmentsTable.getData({ ignoreStored: true });
          }
        }
      }
    );
  }
  public get canCreate() {
    return this.$userCan("create_tickets_departments");
  }
}
